module.exports = __webpack_public_path__ + "img/图片1.2cc7c62c.png";